import { Component, effect } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { BallotListService } from 'src/app/ballot-list/ballot-list.service';
import { Ballot } from 'src/app/ballot/backend-types';
import { HeaderModule } from 'src/app/header/header.module';
import { ballotRoute, dashboardRoute, pollResultsListRoute } from 'src/app/route-names';
import { ApiAboutService } from 'src/app/Services/api-about.service';
import { DialogService, DialogType } from 'src/app/Services/dialog.service';
import { ElectorDataService } from 'src/app/Services/elector-data.service';
import { EventResultsService } from 'src/app/Services/event-results.service';

@Component({
    selector: 'app-poll',
    imports: [HeaderModule, MatProgressSpinnerModule],
    templateUrl: './poll.component.html',
    styleUrl: './poll.component.scss'
})
export class PollComponent {
  errorText: string = "";
  errorTitle: string = "";
  eventId: number = 0;
  eventIndex: number = -1;
  poll: Ballot | undefined;

  displaySpinner: boolean = false;

  constructor (
    private readonly router: Router,
    private readonly aboutService: ApiAboutService,
    readonly ballotListService: BallotListService,
    private readonly dialogService: DialogService,
    private readonly userService: ElectorDataService,
    private readonly resultsService: EventResultsService,
  ) {
    this.eventId = history.state.eventId;
    this.poll = this.ballotListService.getBallots().find((p) => p.eventId === this.eventId);

    if(this.poll) {
      this.eventIndex = this.ballotListService.getBallots().findIndex((p) => p.eventId === this.eventId);
      this.aboutService.headerImageUrl.set(this.userService.getImageUrlForEventOrOrg(this.eventId));
      this.aboutService.headerTitle.set(this.poll.voteEventData.description);
      this.aboutService.headerDates.set(this.ballotListService.formatDateRange(this.poll));
      this.aboutService.setElectionStartAndClose(this.poll.eventActivation, this.poll.eventExpiration);
    }

    effect(() => {
      this.displaySpinner = this.resultsService.displaySpinner();
    })
  }

  backToDashboard() {
    this.router.navigate(dashboardRoute);
  }

  toResultList() {
    this.router.navigate(pollResultsListRoute, {state: {eventId: this.eventId}})
  }

  vote() {
    if(!this.poll || (this.eventIndex < 0)){
      console.error("Missing poll!");
      this.errorTitle = $localize`Missing Poll`;
      this.errorText = $localize`We cannot find this poll. You will be returned to your dashboard.`;
      this.dialogService.openDialog(DialogType.ERROR, this.errorTitle, this.errorText);
      this.router.navigate(dashboardRoute);
    }
   
    this.ballotListService.setBallotService(this.eventIndex);
    this.router.navigate(ballotRoute);
  }

}
